export const APAC_HOTEL_NAME = "apac-Hotels";
export enum ApacHotelsComponent {
  EditHotelSearch = "EditHotelSearch",
  ChildAgePicker = "ChildAgePicker",

  DescriptionDialog = "DescriptionDialog",
  HotelCardPrice = "HotelCardPrice",
  HotelFeatures = "HotelFeatures",
  RoomInfo = "RoomInfo",
  RoomProductList = "RoomProductList",
  RoomProductDetails = "RoomProductDetails",
  RoomFeatures = "RoomFeatures",
  CustomerReview = "CustomerReview",
  HotelStarRating = "HotelStarRating",
  ReviewRatingScale = "ReviewRatingScale",
  HotelTripadvisorRating = "HotelTripadvisorRating",
  LocationWithMap = "LocationWithMap",
  PhotosTab = "PhotosTab",
  ReviewsTab = "ReviewsTab",

  // details tab sections
  AboutHotelSection = "AboutHotelSection",
  CheckInInformationSection = "CheckInInformationSection",
  CheckInPoliciesSection = "CheckInPoliciesSection",
  CustomerReviewsSection = "CustomerReviewsSection",

  BasePriceBreakdown = "BasePriceBreakdown",
  PriceBreakdownReviewSection = "PriceBreakdownReviewSection",
  TotalAmountLines = "TotalAmountLines",
  RewardsAndCredit = "RewardsAndCredit",
  FintechPriceBreakdownSection = "FintechPriceBreakdownSection",
}
